<template>
    <div>
      <div class="">
        <!-- <div class="row">
        <div class="col f-24">
          <span>Monitor : </span><span class="text-info">{{ monitor_data.name }}</span>
        </div>
        </div> -->
              <div class="row">
                  <div class="col call-chat-body cust_h_w">
                <!-- Tabs and Filter Bar -->
                    <div class="monitor-report-tabs-filter">
                      <div class="monitor-report-tabs">
                        <button
                          class="monitor-report-tab"
                          :class="{ active: !chart_tab }"
                          @click="chart_tab = false"
                        >
                          Logs
                        </button>
                        <button
                          class="monitor-report-tab"
                          :class="{ active: chart_tab }"
                          @click="chart_tab = true"
                        >
                          Chart
                        </button>
                      </div>
                      <div class="monitor-report-filter-bar filter-bar-container">
                        <date-range-picker
                          ref="picker"
                          opens="center"
                          :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss A' }"
                          :singleDatePicker="false"
                          :timePicker="true"
                          :timePicker24Hour="false"
                          :showWeekNumbers="false"
                          :showDropdowns="true"
                          :autoApply="false"
                          v-model="dateRange"
                          @update="ChangedDate()"
                          :linkedCalendars="false"
                          :ranges="false"
                          input-class="monitor-report-daterange-input"
                        >
                          <template v-slot:input="picker">
                            <div class="date-range-display" style="min-width: 350px; cursor: pointer; padding: 4px 12px;">
                              <span style="font-size: 90%;"> {{ changeDateFormate(dateRange.startDate) }} - {{ changeDateFormate(dateRange.endDate) }}</span>
                            </div>
                          </template>
                        </date-range-picker>
                        <button class="monitor-report-filter-btn filter-btn-right" @click="Filterlogs()">
                          <img src="@/assets/icons/all-monitors.svg" alt="Filter" width="20" height="20" />
                          <span>Filter</span>
                        </button>
                      </div>
                    </div>
                    <b-row>
                    </b-row>
                    <b-row class="mt-2" v-if="chart_tab">
                      <div v-if="chart_loading" class="col-md-12 mt-5">
                        <h6 class="sub-title mb-0 text-center">Loading...</h6>
                        <div class="loader-box">
                          <div class="loader-30"></div>
                        </div>
                    </div>
                      <div class="col-xl-12 col-md-12 col-sm-12">
                        <px-card title="">
                          <div slot="headerCustom">
                            <span>
                              <h5 class="font-weight-bold">Response Time last 24 hours</h5>
                            </span>
                            <span class="">
                              Shows the "instant" that the monitor started returning a
                              response in ms.
                            </span>
                            </div>
                              <div slot="headerAction" ></div>
                              <div slot="with-padding"  v-if="hasData" >
                                <chartist
                                   
                                    class="ct-4 flot-chart-container"
                                    ratio="ct-major-second"
                                    type="Line"
                                    :data="chartData.data"
                                    :options="chartData.options">
                            </chartist>
          
                              </div>
                               <div v-else class="text-center">
                              <h7 class="sub-title mb-0">There are no records to show</h7>
                              </div>
                          </px-card>
                      </div>
                    </b-row>
                    <b-row class="mt-3 p-2" v-else>
                      <b-col class="col-md-7 col-12">
                        <monitor-logs :monitor_id="monitor_id" :dateRanges='changeDateRange' :update_filter="update_filter"></monitor-logs>
                      </b-col>
                      <b-col class="col-md-5 col-12">
                        <event-vue :monitor_id="monitor_id" :monitor_data="monitor_data" :dateRanges='changeDateRange' :update_filter="update_filter"></event-vue>
                      </b-col>
                    </b-row>
                <!-- </px-card>      -->
                  </div>
              </div>
          </div>
          <div slot="with-padding" v-if="monitor_data.type== 6 || monitor_data.type== 7">
          <div class="row mt-2">
            <div class="col-md-12">
              <!-- <div class="row">
                <div class="col-md-6 col-12">
                  <incedent-vue :monitor_id="monitor_id" :monitor_data="all_monitors" :dateRanges='changeDateRange' :update_filter="update_filter"></incedent-vue>
                </div>
                <div class="col-md-12 col-12">
                  <event-vue :monitor_id="monitor_id" :monitor_data="monitor_data" :dateRanges='changeDateRange' :update_filter="update_filter"></event-vue>
                </div>
              </div> -->
              <div class="row">
                <div class="col-md-12">
                  <pageload-data :monitor_id="monitor_id" :monitor_data="monitor_data" :dateRanges='changeDateRange' :update_filter="update_filter"></pageload-data>
                </div>
              </div>
            </div>
          </div></div>
    </div>
  </template>
  
  
  
  
  <script>
  import IncedentVue from "./Incedent.vue";
  import EventVue from "./Events.vue";
  import MonitorLogs from "./MonitorLogs.vue";
  import PageloadData from "./PageLoadData.vue";
  import MonitorsController from "../../services/monitorController";
  import DashboardController from "../../services/dashboardController";
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
  import moment from 'moment';
  export default {
    name: "ReportFilter",
    components: { IncedentVue, EventVue, PageloadData,MonitorLogs, DateRangePicker },
    props:{monitor_id:String,monitor_data:Object},
    data() {
      return {
        logs_data:[],
        limit:50,
        dateRange: {
          startDate: new Date(new Date().getTime() - (12 * 60 * 60 * 1000)), // 12 hours ago
          endDate: new Date(new Date().getTime() + (12 * 60 * 60 * 1000)),  // 12 hours ahead
        },
        changeDateRange:null,
        chart_tab:false,
        log_tab:true,
        filter_monitor:'',
        monitor_name:'',
        chart_loading: false,
        show_chart: false,
        all_monitors:[],
        filter: {
          monitor: null,
          sdate: "2022-11-11T01:00:00",
          edate: "2022-11-11T23:45:00",
        },
        timelineData: [],
        chartData: {
          data: {
            labels: [
              1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
              20, 21, 22, 23, 24,
            ],
            series: [
              [
                20, 30, 10, 4, 25, 50, 60, 80, 26, 35, 34, 63.75, 87, 43, 12, 43,
                54, 76, 54, 32, 33, 43, 54, 65,
              ],
            ],
          },
          options: {
            low: 0,
            showArea: true,
          },
        },
        monitor_type: {1:'HTTP(s)',2:'Keyword',3:'Ping',4:'Port',5:'Heartbeat',6:'Page Speed',7:'Page Screenshot'},
        update_filter:0
      };
    },
    mounted() {
      this.log_tab=true
      this.getMonitors();
      this.filterData(this.monitor_id);
    },
    methods: {
      Filterlogs(){
          this.changeDateRange = this.dateRange
          this.update_filter = Math.random() * 100;
          this.filterData(this.monitor_id, this.dateRange)
      },
      async getMonitors() {
      let response = await MonitorsController.getMonitors();
      if (response.result) {
        response.data.map((t) => {
          this.all_monitors.push({ value: t._id, text: t.name, type:t.type,isDown:t.isDown });
        });
      }
    },
      changeDateFormate(d){
          return moment(d).format('D/M/YYYY, hh:mm A')
      },
      ChangedDate(){
        // let sdate = new Date(
        //   this.dateRange.startDate.getTime() - this.dateRange.startDate.getTimezoneOffset() * 60000
        // ).toISOString();
  
        // let edate = new Date(
        //   this.dateRange.endDate.getTime() - this.dateRange.endDate.getTimezoneOffset() * 60000
        // ).toISOString();
        // this.dateRange.startDate = sdate
        // this.dateRange.endDate = edate
        // this.filterData(this.monitor_id, this.dateRange)
      },
      async filterData(value,dateRange) {
        this.monitor_id = value;
        this.show_chart = false;
        this.chart_loading = false;
        if (this.monitor_id) {
          this.chart_loading = true;
          this.chartData.data.labels = [];
          this.chartData.data.series = [];
          let payload = {
            dim: {
              mid: [this.monitor_id]
            },
            limit:this.limit
          };
          if(dateRange){
            payload.sdate = dateRange.startDate
            payload.edate = dateRange.endDate
          }
          let response = await DashboardController.timelineData(payload);
         
          if (response.result) {
            if(response.data.length>0){
            this.hasData = true;  
            this.timelineData = response.data;
            this.timelineData.map((t) => {
              this.chartData.data.labels.push(t.hour);
            });
            this.chartData.data.series.push(
              this.timelineData.map((t) => {
                return t.rtime;
              })
            );
            this.show_chart = true;
           
          }
          else{
            this.hasData = false;  
           // this.$toasted.show('There are no records to show', {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
          }
            this.chart_loading = false;
          }
           
           this.chart_loading = false;
        }
      }
    },
  };
  </script>
  
  
  <style>
  .ct-series-a .ct-slice-pie,
  .ct-series-a .ct-slice-donut-solid,
  .ct-series-a .ct-area {
    fill: #989219 !important;
  }
  .ct-series-a .ct-point,
  .ct-series-a .ct-line,
  .ct-series-a .ct-bar,
  .ct-series-a .ct-slice-donut {
    stroke: #989219 !important;
  }
  .ct-area {
    fill-opacity: 0.6 !important;
  }
  .custom-badge{
    background:#999;color:white;font-size: 9px !important;
  }
  .monitor_filter{
        position: sticky;
      top: 0;
  }
  .daterangepicker th.prev, .daterangepicker th.next, .daterangepicker td.prev, .daterangepicker td.next {
    background: none !important;
  }
  .cust_h_w{
    min-height:60vh;max-height:75vh;overflow:scroll;
  }
  @media (max-width: 767px) {
    .cust_h_w {
      min-height:auto;max-height:auto;overflow:scroll;
    }
  }

.monitor-report-header {
  text-align: center;
  margin-top: 0;
  margin-bottom: 12px;
}
.monitor-report-title {
  font-family: 'Poppins', sans-serif;
  font-size: 2rem;
  font-weight: 700;
  color: #232323;
  margin-bottom: 8px;
}
.monitor-report-divider {
  width: 100%;
  height: 1.5px;
  background: #E5E7EB;
  margin: 0 auto 18px auto;
}
.monitor-report-tabs-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}
.monitor-report-tabs {
  display: flex;
  gap: 0;
  background: #F4F8FF;
  border-radius: 14px;
  overflow: hidden;
}
.monitor-report-tab {
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #101828;
  background: #F4F8FF;
  border: none;
  outline: none;
  padding: 12px 78px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.monitor-report-tab.active {
  background: #2FB234;
  color: #fff;
}
.monitor-report-filter-bar {
  display: flex;
  align-items: center;
  background: #fff;
  gap: 18px;
}
.monitor-report-filter-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #101828;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  padding: 8px 22px;
  cursor: pointer;
  transition: background 0.2s;
}
.monitor-report-filter-btn:hover {
  background: #232323;
}
.monitor-report-main-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 12px 0 rgba(16, 24, 40, 0.07);
  padding: 32px 24px 24px 24px;
  margin: 0 auto;
  max-width: 1200px;
}
.monitor-report-logs-latest-row {
  display: flex;
  gap: 32px;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}
.monitor-report-logs-col, .monitor-report-latest-col {
  flex: 1 1 0;
  min-width: 340px;
  max-width: 50%;
}
.monitor-report-table-card {
  background: #fff;
  border: 1.5px solid #D2E3FB;
  border-radius: 16px;
  padding: 18px 18px 0 18px;
  margin-bottom: 0;
  min-height: 420px;
  box-shadow: 0 1px 4px 0 rgba(16, 24, 40, 0.04);
}
.monitor-report-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.monitor-report-table-title {
  font-family: 'Poppins', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: #232323;
}
.monitor-report-per-page {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1.5px solid #D2E3FB;
  border-radius: 10px;
  padding: 3px 16px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  height: 47px;
  gap: 8px;
}
.per-page-icon {
  width: 16px;
  height: 18px;
}
.select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}
@media (max-width: 1100px) {
  .monitor-report-logs-latest-row {
    flex-direction: column;
    gap: 24px;
  }
  .monitor-report-logs-col, .monitor-report-latest-col {
    max-width: 100%;
  }
}
.filter-bar-container {
  display: flex;
  align-items: center;
  border-radius: 12px;
  border: 1px solid #D0D5DD;
  background: #fff;
  padding: 0;
  overflow: visible;
  min-width: 420px;
  position: relative;
}
.vue-daterange-picker, .form-control{
  border: none !important;
  border-radius: 12px !important;
}
.monitor-report-daterange-input {
  cursor: pointer !important;
  background: transparent !important;
  min-width: 280px !important;
}
.vue-daterange-picker {
  flex: 1;
  position: relative;
  pointer-events: auto !important;
  border: none !important;
}
.daterangepicker {
  z-index: 9999 !important;
}
.date-range-display {
  pointer-events: auto !important;
}
.monitor-report-filter-bar {
  pointer-events: auto !important;
}
.filter-btn-right {
  border-radius: 12px !important;
  margin-left: 0 !important;
  height: 100%;
  min-width: 120px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #101828;
  border: none;
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
}
  </style>